

export const narrowMediaQuery = window.matchMedia('(max-width: 833px)');
export const wideMediaQuery = window.matchMedia('(min-width: 834px)');



// WEBPACK FOOTER //
// ./src/js/app/mediaQuery.js